import type {Locale} from '../../i18n.config';
import type {BlurDataURLs, GuideFM, Content} from '../library/types';
import Guide from './Guide';

type Props = {
  locale: Locale;
  guides: Content<GuideFM>[];
  blurDataURLs: BlurDataURLs;
};

export default function GuidesFallback({locale, guides, blurDataURLs}: Props) {
  return (
    <ul>
      {guides.map((guide, index) => (
        <Guide
          key={guide.scope.slug}
          locale={locale}
          guide={guide}
          priority={index < 2}
          blurDataURL={blurDataURLs[guide.frontmatter.image]}
        />
      ))}
    </ul>
  );
}
